import axios from 'axios';
import { add } from 'date-fns';

const apiCallMicroservice = axios.create({
  baseURL: process.env.REACT_APP_CALL_MICROSERVICE_API_URL || 'https://boaztech-delivery-calls.herokuapp.com'
});

export class BoazRemoteCallService {
  static async getNewToken() {
    const clientKey = process.env.REACT_APP_CALL_MICROSERVICE_API_KEY || 'cmiWGbIFaJEkDPyaPWCdq9OVgrKh3bmm';
    if (!clientKey) return;
    const clientName = process.env.REACT_APP_CALL_MICROSERVICE_CLIENT_NAME || 'remoteSystem';
    if (!clientName) return;

    const requestBody = {
      username: clientName,
      password: clientKey
    };
    // eslint-disable-next-line consistent-return
    return apiCallMicroservice.post('auth/token', requestBody).then((response) => {
      const currentDateTime = new Date();
      const result = {
        token: response.data.token,
        expiresAt: add(currentDateTime, { minutes: 120 })
      };
      return result;
    }).catch((err) => {
      // eslint-disable-next-line no-console
      console.warn(err);
      return null;
    });
  }
}

export default apiCallMicroservice;
